import { useAuth } from '../../auth/AuthContext'
import { useWalletBalances } from '../../hooks/useWalletBalance'
import { useWalletAdapterBridge } from '../../lib/walletBridge'
import SwapForm from '../trade/SwapForm'
import WalletTopUpCard from './WalletTopUpCard'
import type { WalletTopUpSuggestion } from '../../types/strategy'

interface Props {
  onClose: () => void
  onSwapSuccess?: () => void
  walletTopUp?: WalletTopUpSuggestion | null
}

export default function JupiterSwapPanel({ onClose, onSwapSuccess, walletTopUp }: Props) {
  const { portfolioId } = useAuth()
  const balances = useWalletBalances(portfolioId)
  useWalletAdapterBridge()

  return (
    <div className="fixed inset-0 z-50 flex justify-end" onClick={onClose}>
      <div
        className="relative w-full max-w-lg bg-[#131a2a] border-l border-fringe-strong shadow-2xl flex flex-col h-full animate-slide-in-right overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 px-4 py-3 border-b border-fringe-strong shrink-0">
          <div className="w-6 h-6 rounded-lg bg-accent-purple/10 flex items-center justify-center shrink-0">
            <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-accent-purple" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 3l4 4-4 4M3 7h18M7 21l-4-4 4-4M21 17H3"/>
            </svg>
          </div>
          <span className="text-sm font-bold text-ink">Jupiter Swap</span>
          <span className="text-[10px] text-gray-500">Any ↔ any via aggregator</span>
          <button onClick={onClose} className="ml-auto text-gray-500 hover:text-ink transition-colors p-1">
            <svg viewBox="0 0 16 16" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="3" x2="13" y2="13" /><line x1="13" y1="3" x2="3" y2="13" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {walletTopUp && <WalletTopUpCard suggestion={walletTopUp} />}
          <SwapForm balances={balances} onSuccess={onSwapSuccess} />
        </div>
      </div>
    </div>
  )
}
